const environments = {
  development: require('./development'),
  staging: require('./staging'),
  test: require('./test'),
  production: require('./production'),
};

module.exports = environments[process.env.REACT_APP_ENV || 'development'];
